@if (breadcrumbs && breadcrumbs.length > 0) {
    <div>
        @for (bc of breadcrumbs; track bc) {
            @if (bc.route != '') {
                <a style="color:#999999; text-decoration: underline;" [routerLink]="bc.route">{{bc.label}}</a>
            } @else {
                <span style="color:#999999;">{{bc.label}}</span>
            }
            @if (bc !== breadcrumbs[breadcrumbs.length - 1]) {
                <span style="color:#999999;">&nbsp;&nbsp;&gt;&nbsp;&nbsp;</span>
            }
        }
    </div>
}
